import { ApiCall } from '../../services/http-service/types/ApiCall';
import httpService from '../../services/http-service';
import { portalLevelPermissions } from './PortalLevelPermissions';

export const getPortalLevelPermissions: ApiCall<undefined, void> = async ({ abortSignal }) => {
  try {
    const { data } = await httpService.get(
      '/api/v3/account/authorization/permissions',
      null,
      abortSignal,
    );
    portalLevelPermissions.initialize(data);
  } catch (error) {
    portalLevelPermissions.reset();
    throw error;
  }
};